import React, { useState, useEffect } from 'react';

interface TabItem {
  title: string;
  iconUrl?: string;
  callback: Function;
}

interface Props {
  items: TabItem[];
  active?: number;
  type?: string;
}

const TabMenu: React.FC<Props> = ({ items, active, type }) => {
  const [activeTab, setActiveTab] = useState(active ? active : 0);

  useEffect(() => {
    if (active !== undefined && active !== activeTab) {
      setActiveTab(active);
    }

  }, [active])



  const click = (item: TabItem, index: number) => {
    setActiveTab(index);
    item.callback()
  }

  if (type === "buttons") {
    const inactiveClasses = 'text-gray-950 cursor-pointer hover:bg-gray-400';
    const activeClasses = 'bg-gray-400'
    return (
      <>
        {/* Tab headers */}
        <div className="flex gap-x-2">
          {items.map((item, index) => (
            <div key={"tab_" + index}
                 className={"rounded-full border border-gray-400 flex items-center px-4 py-2 " + (activeTab === index ? activeClasses : inactiveClasses)}
                 onClick={() => click(item, index)}
            >
              {
                item.iconUrl &&
                  <img src={item.iconUrl} className="h-4 mr-2" alt="icon" />
              }
              <div className="text-sm font-medium">{item.title}</div>
            </div>
          ))}
        </div>
      </>
    );
  }

  const inactiveClasses = 'text-gray-500 whitespace-nowrap cursor-pointer hover:text-gray-800 hover:border-b hover:border-b-gray-800';
  const activeClasses = 'border-b border-b-gray-800 text-gray-800'

  return (
    <>
      {/* Tab headers */}
      <div className="flex border-b pb-2 border-b-gray-600">
          {items.map((item, index) => (
            <div key={"tab_" + index}
              className={"mr-4 h-6 flex items-center pb-2 " + (activeTab === index ? activeClasses : inactiveClasses)}
              onClick={() => click(item, index)}
              style={{marginBottom: "-8px"}}
            >
              {
                item.iconUrl &&
                  <img src={item.iconUrl} className="h-4 mr-2" alt="icon" />
              }
              <div className="font-medium">{item.title}</div>
            </div>
          ))}
      </div>
    </>
  );
}

export default TabMenu;